// Angular
import { isPlatformBrowser } from '@angular/common';
import { Directive, HostListener, PLATFORM_ID, input, inject } from '@angular/core';
// Environment
import { environment } from '@environment';

/**
 * Directive to the track Google analytics event
 * @export
 * @class GaCustomEventDirective
 */
@Directive({ selector: '[gaCustomEvent]' })
export class GaCustomEventDirective {
    private platformId = inject<Object>(PLATFORM_ID);

    // Input
    readonly gaEventName = input.required<string>();
    readonly gaEventData = input.required<any>({});

    /**
     * Click Event
     * @memberof GaCustomEventDirective
     */
    @HostListener('click') onClick() {
        try {
            if (environment.googleAnalytics.isEnabled && isPlatformBrowser(this.platformId)) {
                gtag('event', this.gaEventName(), this.gaEventData());
            }
        } catch (error) {
            console.log('custom-ga4-event', error);
        }
    }
}
